/* ============================================================
 * <lion-product-form> — wraps the product page <form action="/cart/add">
 * Intercepts submit, POSTs via AJAX, publishes cart-update so the
 * <lion-cart-drawer> refreshes and opens.
 * ============================================================ */

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.querySelector('[name=id]')?.removeAttribute('disabled');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.errorTarget = this.querySelector('[data-product-form-error]');
    this.cartType = document.querySelector('lion-cart-drawer') ? 'drawer' : (window.lionCartType || 'page');
  }

  async onSubmit(event) {
    if (this.cartType === 'page') return; // let native submit go to /cart
    event.preventDefault();
    if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();
    this.submitButton?.setAttribute('aria-disabled', 'true');
    this.submitButton?.classList.add('loading');

    const formData = new FormData(this.form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    try {
      const res = await fetch(`${window.shopUrls.cart_add}`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();

      if (data.status) {
        // error payload from Shopify: { status, description, message }
        this.handleErrorMessage(data.description || data.message || 'Error adding to cart');
        window.publish?.(window.PUB_SUB_EVENTS.cartError, { source: 'lion-product-form', message: data.description });
        return;
      }

      // Ask lion-cart-drawer to refresh itself from returned section HTML (if any)
      const drawer = document.querySelector('lion-cart-drawer');
      const sectionHtml = data.sections?.['cart-drawer'];
      if (drawer && sectionHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const fresh = doc.querySelector('lion-cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        drawer.querySelectorAll('[data-cart-drawer-close]').forEach((el) =>
          el.addEventListener('click', () => drawer.close())
        );
        drawer.updateHeaderBadge();
      }

      window.publish?.(window.PUB_SUB_EVENTS.cartUpdate, {
        source: this.dataset.source || 'lion-product-form',
        productVariantId: formData.get('id')
      });
    } catch (err) {
      console.error('[lion-product-form] add-to-cart failed:', err);
      this.handleErrorMessage('Network error. Please try again.');
    } finally {
      this.submitButton?.removeAttribute('aria-disabled');
      this.submitButton?.classList.remove('loading');
    }
  }

  handleErrorMessage(message = false) {
    if (!this.errorTarget) return;
    if (message === false) {
      this.errorTarget.hidden = true;
      this.errorTarget.textContent = '';
      return;
    }
    this.errorTarget.hidden = false;
    this.errorTarget.textContent = message;
  }
}
if (!customElements.get('lion-product-form')) {
  customElements.define('lion-product-form', ProductForm);
}
